// Étiquette « reprise » : 2 petites étiquettes (28,5 x 20 mm, même imprimante que les casiers).
//  1) n° de reprise, nom du téléphone (grand), IMEI
//  2) prix en €, emplacement (allée/rangée/tiroir/position) et ID avec QR code — style étiquette de stock.
import { newSheet, finishSheet, drawQr } from "./casierLabel";

const F = (w, s) => `${w} ${s}px Arial, Helvetica, sans-serif`;

function fitFont(ctx, text, weight, maxSize, minSize, maxW) {
  let s = maxSize;
  ctx.font = F(weight, s);
  while (s > minSize && ctx.measureText(text).width > maxW) { s -= 1; ctx.font = F(weight, s); }
  return s;
}

// Découpe en lignes (mots) pour tenir dans maxW ; renvoie null si > maxLines.
function wrap(ctx, text, maxW, maxLines) {
  const words = text.split(/\s+/).filter(Boolean);
  const lines = [];
  let cur = "";
  for (const w of words) {
    const t = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(t).width <= maxW) cur = t;
    else { if (cur) lines.push(cur); cur = w; if (ctx.measureText(w).width > maxW) return null; }
  }
  if (cur) lines.push(cur);
  return lines.length <= maxLines ? lines : null;
}

export function emplacement({ allee, rangee, tiroir, position }) {
  return [allee, rangee, tiroir, position].map((v) => String(v || "").trim().toUpperCase()).filter(Boolean).join("/");
}
export function formatPrix(prix) {
  const t = String(prix ?? "").trim().replace(",", ".");
  if (!t) return "";
  const n = Number(t);
  return Number.isFinite(n) ? `${Number.isInteger(n) ? n : n.toFixed(2).replace(".", ",")}€` : `${String(prix).trim()}€`;
}

export function renderRepriseLabel1({ numero, nom, imei }) {
  const { c, ctx, x0, LW, H } = newSheet();
  const m = 8, maxW = LW - 2 * m, cx = x0 + LW / 2;
  ctx.textAlign = "center";
  let y = m;
  if (numero) {
    const s = fitFont(ctx, `Reprise n° ${numero}`, "bold", 26, 14, maxW);
    y += Math.round(s * 0.76); ctx.fillText(`Reprise n° ${numero}`, cx, y); y += 6;
  }
  const bottom = imei ? H - m - 18 : H - m; // place réservée à l'IMEI
  // Nom du téléphone : la plus grande police qui tient en <= 3 lignes dans la zone restante.
  const zoneH = bottom - y;
  const nomT = (nom || "").trim();
  if (nomT) {
    for (let s = 60; s >= 14; s -= 2) {
      ctx.font = F("bold", s);
      const lines = wrap(ctx, nomT, maxW, 3);
      const lh = Math.round(s * 1.08);
      if (lines && lines.length * lh <= zoneH) {
        const top = y + Math.round((zoneH - lines.length * lh) / 2);
        lines.forEach((l, i) => ctx.fillText(l, cx, top + Math.round(s * 0.8) + i * lh));
        break;
      }
      if (s === 14) { ctx.font = F("bold", 14); ctx.fillText(nomT.slice(0, 22), cx, y + 20); }
    }
  }
  if (imei) {
    const t = `IMEI ${imei}`;
    fitFont(ctx, t, "normal", 20, 10, maxW);
    ctx.fillText(t, cx, H - m);
  }
  return finishSheet(c);
}

export function renderRepriseLabel2({ prix, emplacementTxt, id }) {
  const { c, ctx, x0, LW, H } = newSheet();
  const m = 8;
  // Colonne droite : QR + ID dessous (police normale, comme l'étiquette de stock).
  const qrBox = 84;
  const rx = x0 + LW - m - qrBox;
  let qrSize = 0;
  if (id) {
    const probe = document.createElement("canvas").getContext("2d");
    const size = drawQr(probe, id, 0, 0, qrBox, 2, 4); // mesure seule
    const top = Math.round((H - (size + 26)) / 2);
    qrSize = drawQr(ctx, id, rx, top, qrBox, 2, 4);
    ctx.textAlign = "center";
    const fs = fitFont(ctx, id, "normal", 24, 12, qrBox + 6);
    ctx.fillText(id, rx + qrSize / 2, top + qrSize + 6 + Math.round(fs * 0.76));
  }
  // Colonne gauche : prix puis emplacement, centrés verticalement.
  const maxW = (id ? rx - 6 : x0 + LW - m) - (x0 + m);
  ctx.textAlign = "left";
  const lignes = [];
  if (prix) lignes.push({ t: prix, w: "normal", max: 38 });
  if (emplacementTxt) lignes.push({ t: emplacementTxt, w: "normal", max: 28 });
  const gap = 10;
  const sizes = lignes.map((l) => fitFont(ctx, l.t, l.w, l.max, 12, maxW));
  const total = sizes.reduce((a, s) => a + s * 0.78, 0) + gap * Math.max(0, lignes.length - 1);
  let y = Math.round((H - total) / 2);
  lignes.forEach((l, i) => {
    const s = sizes[i];
    y += Math.round(s * 0.78);
    ctx.font = F(l.w, s);
    ctx.fillText(l.t, x0 + m, y);
    y += gap;
  });
  return finishSheet(c);
}
